<script lang="ts" module>
  import { tv } from 'tailwind-variants';

  export interface ToDoPillProps {
    title: string;
    score: number;
    color?: DimColor;
  }

  export type DimColor = 'success' | 'warning' | 'error' | 'info';

  const styles = tv({
    base: 'rounded-sm px-3 py-1 !text-label-sm font-medium text-c-base',
    variants: {
      dimension: {
        success: 'bg-success',
        warning: 'bg-warning',
        error: 'bg-error',
        info: 'bg-info',
      },
    },
  });
</script>

<script lang="ts">
  let { ...props }: ToDoPillProps = $props();
  let cn = $derived(styles({ dimension: getColor() }));

  function getColor(): DimColor {
    if (props.color) {
      return props.color;
    } else if (props.score >= 100) {
      return 'success';
    } else if (props.score >= 50) {
      return 'warning';
    } else if (props.score >= 0) {
      return 'error';
    } else {
      return 'info';
    }
  }
</script>

<span class={cn}>{props.title}</span>
